import { myralisTokens } from './tokens';

const styleId = 'myralis-surface-theme-fix';

const surfaceTheme = `
  html body,
  html body #root,
  html body .BackstageSidebarPage-root,
  html body [class*='SidebarPage-root'],
  html body main,
  html body [role='main'] {
    color: ${myralisTokens.colors.text} !important;
    background: ${myralisTokens.colors.surfaceMuted} !important;
    background-color: ${myralisTokens.colors.surfaceMuted} !important;
  }

  html body .MuiPaper-root,
  html body .MuiCard-root,
  html body [class*='MuiPaper-root'],
  html body [class*='MuiCard-root'],
  html body [class*='BackstageTable-root'] .MuiPaper-root {
    color: ${myralisTokens.colors.text} !important;
    background: ${myralisTokens.colors.surface} !important;
    background-color: ${myralisTokens.colors.surface} !important;
    border-color: ${myralisTokens.colors.border} !important;
  }

  html body .MuiTable-root,
  html body .MuiTableBody-root,
  html body .MuiTableBody-root .MuiTableRow-root,
  html body .MuiTableBody-root .MuiTableCell-root {
    color: ${myralisTokens.colors.text} !important;
    background: ${myralisTokens.colors.surface} !important;
    background-color: ${myralisTokens.colors.surface} !important;
  }

  html body .MuiTableCell-root a,
  html body .MuiTableCell-root a span,
  html body .MuiTableCell-root svg {
    color: ${myralisTokens.colors.institutionalBlue} !important;
    font-weight: 700 !important;
  }

  html body .MuiPaper-root .MuiTypography-root,
  html body .MuiPaper-root .MuiTableCell-root,
  html body .MuiPaper-root p,
  html body .MuiPaper-root span,
  html body .MuiPaper-root div {
    color: ${myralisTokens.colors.text} !important;
  }

  html body .MuiPaper-root .MuiTypography-h1,
  html body .MuiPaper-root .MuiTypography-h2,
  html body .MuiPaper-root .MuiTypography-h3,
  html body .MuiPaper-root .MuiTypography-h4,
  html body .MuiPaper-root h1,
  html body .MuiPaper-root h2,
  html body .MuiPaper-root h3 {
    color: ${myralisTokens.colors.institutionalBlue} !important;
  }

  html body .MuiPaper-root .MuiTableHead-root .MuiTableCell-root,
  html body .MuiPaper-root .MuiTableHead-root .MuiTableCell-root span,
  html body .MuiPaper-root .MuiTableHead-root .MuiTableCell-root div {
    color: ${myralisTokens.colors.institutionalBlue} !important;
    background: #FDFEFF !important;
    background-color: #FDFEFF !important;
  }

  html body .MuiTabs-root .MuiTab-root {
    color: rgba(8, 68, 126, 0.72) !important;
  }

  html body .MuiTabs-root .MuiTab-root.Mui-selected {
    color: ${myralisTokens.colors.primary} !important;
  }

  html body .MuiTabs-root,
  html body .MuiTabs-scroller,
  html body .MuiTabs-flexContainer,
  html body [role='tablist'] {
    background: ${myralisTokens.colors.surface} !important;
    background-color: ${myralisTokens.colors.surface} !important;
  }

  html body .MuiTabs-indicator {
    background-color: ${myralisTokens.colors.coral} !important;
  }

  html body .BackstageHeader-header,
  html body [class*='BackstageHeader-header'] {
    color: ${myralisTokens.colors.white} !important;
    background:
      radial-gradient(circle at 18% -35%, rgba(166, 179, 255, 0.48), transparent 34%),
      radial-gradient(circle at 92% 0%, rgba(255, 255, 255, 0.18), transparent 28%),
      linear-gradient(105deg, ${myralisTokens.colors.primary} 0%, ${myralisTokens.colors.institutionalBlue} 100%) !important;
    background-color: ${myralisTokens.colors.primary} !important;
  }

  html body .BackstageHeader-header *,
  html body [class*='BackstageHeader-header'] * {
    color: ${myralisTokens.colors.white} !important;
  }

  html body .BackstageHeader-header svg,
  html body [class*='BackstageHeader-header'] svg {
    color: ${myralisTokens.colors.white} !important;
    fill: currentColor !important;
  }

  html body main > header {
    color: ${myralisTokens.colors.white} !important;
    background:
      radial-gradient(circle at 18% -35%, rgba(166, 179, 255, 0.48), transparent 34%),
      radial-gradient(circle at 92% 0%, rgba(255, 255, 255, 0.18), transparent 28%),
      linear-gradient(105deg, ${myralisTokens.colors.primary} 0%, ${myralisTokens.colors.institutionalBlue} 100%) !important;
    background-color: ${myralisTokens.colors.primary} !important;
  }

  html body main > header *,
  html body main > header svg {
    color: ${myralisTokens.colors.white} !important;
  }

  html body main > header svg {
    fill: currentColor !important;
  }

  html body .MuiOutlinedInput-notchedOutline,
  html body .MuiInputBase-root,
  html body .MuiPaper-root .MuiPaper-root {
    border-color: ${myralisTokens.colors.border} !important;
  }

  html body [class*='bui-Card'] {
    color: ${myralisTokens.colors.text} !important;
    background: ${myralisTokens.colors.surface} !important;
    background-color: ${myralisTokens.colors.surface} !important;
    border-color: ${myralisTokens.colors.border} !important;
  }

  html body [class*='bui-Card'] *,
  html body [class*='bui-Grid'] *,
  html body [class*='bui-Table'] * {
    color: ${myralisTokens.colors.text} !important;
  }

  html body input.MuiInputBase-input,
  html body textarea.MuiInputBase-input,
  html body .MuiOutlinedInput-input,
  html body .MuiFilledInput-input,
  html body .MuiInput-input,
  html body .MuiAutocomplete-input,
  html body [class*='bui-Card'] input.MuiInputBase-input,
  html body [class*='bui-Card'] textarea.MuiInputBase-input {
    color: ${myralisTokens.colors.text} !important;
    -webkit-text-fill-color: ${myralisTokens.colors.text} !important;
    caret-color: ${myralisTokens.colors.primary} !important;
    background: ${myralisTokens.colors.surface} !important;
    background-color: ${myralisTokens.colors.surface} !important;
  }

  html body input.MuiInputBase-input::placeholder,
  html body textarea.MuiInputBase-input::placeholder,
  html body .MuiOutlinedInput-input::placeholder {
    color: ${myralisTokens.colors.textMuted} !important;
    -webkit-text-fill-color: ${myralisTokens.colors.textMuted} !important;
    opacity: 1 !important;
  }

  html body input.MuiInputBase-input:-webkit-autofill,
  html body textarea.MuiInputBase-input:-webkit-autofill,
  html body .MuiOutlinedInput-input:-webkit-autofill {
    -webkit-text-fill-color: ${myralisTokens.colors.text} !important;
    box-shadow: 0 0 0 1000px ${myralisTokens.colors.surface} inset !important;
  }

  html body [class*='bui-CardHeader'],
  html body [class*='bui-CardHeader'] *,
  html body [class*='bui-TableHeader'],
  html body [class*='bui-TableHeader'] *,
  html body [class*='bui-TableHead'],
  html body [class*='bui-TableHead'] * {
    color: ${myralisTokens.colors.institutionalBlue} !important;
    background: ${myralisTokens.colors.surface} !important;
    background-color: ${myralisTokens.colors.surface} !important;
  }

  html body [class*='bui-Card'] .MuiChip-root,
  html body [class*='bui-Card'] [class*='MuiChip-root'] {
    color: ${myralisTokens.colors.institutionalBlue} !important;
    background: ${myralisTokens.colors.surfaceSoft} !important;
    background-color: ${myralisTokens.colors.surfaceSoft} !important;
    border-color: ${myralisTokens.colors.border} !important;
  }
`;

const applySurfaceThemeFix = () => {
  const existing = document.getElementById(styleId);

  if (existing && existing.parentElement?.lastElementChild === existing) {
    return;
  }

  existing?.remove();

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = surfaceTheme;
  document.head.appendChild(style);
};

if (typeof document !== 'undefined') {
  const observer = new MutationObserver(applySurfaceThemeFix);

  const startObserver = () => {
    applySurfaceThemeFix();
    observer.observe(document.head, {
      childList: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
}
